import * as React from 'react';
import { Link } from 'react-router-dom';
import { ProfileContext, Profile } from '../profile';
const isAdmin = (profile: Profile) => profile.type === 'admin';

export default () => {
  const { profile } = React.useContext(ProfileContext);

  if (!profile) {
    return (
      <header className="w-100 sans-serif bg-white black bg-white bb bw b--black-10">
        <div className="mw9 ml-auto mr-auto flex justify-center items-center ph2 ph4-ns">
          <Link to="/dashboard" className="db tc link black dim ma3">
            <img
              className="br2 h2 w2 db"
              src="/images/filtru.png"
              alt="Filtru Business"
            />
          </Link>
        </div>
      </header>
    );
  }

  const routes: any = {
    dashboard: 'Dashboard',
    guides: 'Brew Guides',
    company: 'Brand Page',
  };

  if (profile.company) {
    routes.orders = 'Orders';
    routes.products = 'Products';
    routes['shipping-methods'] = 'Shipping';
    routes.invitations = 'Invite members';
  }

  if (isAdmin(profile)) {
    routes.feeds = 'Feeds';
    routes.contracts = 'Contracts';
    routes.categories = 'Categories';
  }

  return (
    <header className="w-100 sans-serif bg-white black bg-white bb bw b--black-10">
      <div className="mw9 ml-auto mr-auto flex items-center ph2 ph4-ns">
        <Link to="/dashboard" className="db tc link black dim">
          <img
            className="br2 h2 w2 db"
            src="/images/filtru.png"
            alt="Filtru Business"
          />
        </Link>
        <menu className="flex items-center flex-auto">
          {Object.keys(routes).map((key: string) => (
            <Link
              to={`/${key}`}
              className="b db link black pa3 br3 hover-bg-near-white bg-white"
            >
              {routes[key]}
            </Link>
          ))}
        </menu>
        <div>
          <Link
            to="/profile"
            className="b db link black pa3 br3 hover-bg-near-white bg-white"
          >
            <p className="ma0">{profile.name}</p>
            {profile.company && (
              <span className="normal f7">{profile.company.name}</span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
};
